export const ID_AI_CHAT = 'sofia-ai-assistant';
export const NAME_AI_CHAT = 'София-AI';
export const URL_AI_CHAT_AVATAR_LOGO = '/imgs/ai-chat-avatar-logo.png';
